module.exports = __webpack_public_path__ + "img/kuaishou.a360bb8b.png";